var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "requests" },
    [
      _vm.hasNewLeftNavEnabled
        ? _c(
            "new-main-header",
            {
              attrs: {
                "show-plc-button": !_vm.isFraud,
                "show-one-off-button": !_vm.isFraud,
              },
            },
            [_vm._v("\n    Customer Requests\n  ")]
          )
        : _c(
            "main-header",
            {
              attrs: {
                "show-plc-button": true && !_vm.isFraud,
                "show-one-off-button": true && !_vm.isFraud,
              },
            },
            [
              _c(
                "span",
                { attrs: { slot: "arrow-back" }, slot: "arrow-back" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: "Back to Start Page",
                        placement: "bottom-start",
                      },
                    },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "HomePage" } } },
                        [_c("i", { staticClass: "el-icon-back" })]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                { attrs: { slot: "page-title" }, slot: "page-title" },
                [_vm._v("Customer Requests")]
              ),
            ]
          ),
      _vm._v(" "),
      _c("main-content", [
        _c(
          "div",
          { attrs: { slot: "main-content" }, slot: "main-content" },
          [
            _c(
              "div",
              { staticStyle: { margin: "10px 0px", "text-align": "right" } },
              [
                _c(
                  "el-popover",
                  {
                    attrs: {
                      placement: "left",
                      title: "Search and Filter",
                      width: "400",
                      trigger: "click",
                    },
                    model: {
                      value: _vm.visible,
                      callback: function ($$v) {
                        _vm.visible = $$v
                      },
                      expression: "visible",
                    },
                  },
                  [
                    _c(
                      "el-form",
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "UUID" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "Search by UUID" },
                              model: {
                                value: _vm.q.uuid,
                                callback: function ($$v) {
                                  _vm.$set(_vm.q, "uuid", $$v)
                                },
                                expression: "q.uuid",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "GID" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "Search by GID" },
                              model: {
                                value: _vm.q.gid,
                                callback: function ($$v) {
                                  _vm.$set(_vm.q, "gid", $$v)
                                },
                                expression: "q.gid",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Device ID" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "Search by Mac Address" },
                              model: {
                                value: _vm.q.device_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.q, "device_id", $$v)
                                },
                                expression: "q.device_id",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "State" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  filterable: "",
                                  placeholder: "Search by state",
                                },
                                model: {
                                  value: _vm.q.state,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.q, "state", $$v)
                                  },
                                  expression: "q.state",
                                },
                              },
                              _vm._l(_vm.statusList, function (state) {
                                return _c("el-option", {
                                  key: state.value,
                                  attrs: {
                                    value: state.value,
                                    label: state.label,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { width: "100%", padding: "10px" },
                                attrs: { type: "info" },
                                on: {
                                  click: function ($event) {
                                    return _vm.makeSearch()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Search\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button-group",
                      { attrs: { slot: "reference" }, slot: "reference" },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { padding: "11px 20px 10px" },
                            attrs: { type: "info", round: "" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("requests.search")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isFiltered
                          ? _c("el-button", {
                              staticStyle: { padding: "10px 20px" },
                              attrs: {
                                type: "info",
                                round: "",
                                icon: "el-icon-close",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.clearParams()
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isFiltered
                  ? _c(
                      "div",
                      { staticStyle: { "margin-top": "10px" } },
                      _vm._l(_vm.currentFilters, function (filter, i) {
                        return _c(
                          "el-tag",
                          {
                            key: i,
                            staticStyle: { "margin-right": "3px" },
                            attrs: { type: "info", size: "medium" },
                          },
                          [
                            _vm._v(
                              "\n            " + _vm._s(filter) + "\n          "
                            ),
                          ]
                        )
                      }),
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-tabs",
              {
                staticClass: "ring-tabs-nav",
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { name: "replacement" } },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _c(
                          "el-badge",
                          {
                            staticClass: "item",
                            attrs: {
                              value: _vm.replacementSize,
                              hidden: _vm.replacementSize === 0,
                              type: "primary",
                            },
                          },
                          [_c("span", [_vm._v("Replacements")])]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("replacement-list", {
                      attrs: {
                        loading: _vm.loading,
                        requests: _vm.requestList.replacement,
                        "status-list": _vm.statusList,
                      },
                      on: {
                        reload: _vm.loadRequests,
                        "cancel-request": function (requestId) {
                          return _vm.cancelRequest(requestId)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tab-pane",
                  { attrs: { name: "one_off" } },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _c(
                          "el-badge",
                          {
                            staticClass: "item",
                            attrs: {
                              value: _vm.oneOffsSize,
                              hidden: _vm.oneOffsSize === 0,
                              type: "primary",
                            },
                          },
                          [_c("span", [_vm._v("One Off")])]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("one-off-list", {
                      attrs: {
                        loading: _vm.loading,
                        requests: _vm.requestList.one_off,
                        "status-list": _vm.statusList,
                      },
                      on: { reload: _vm.loadRequests },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tab-pane",
                  { attrs: { name: "parts" } },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _c(
                          "el-badge",
                          {
                            staticClass: "item",
                            attrs: {
                              value: _vm.partsSize,
                              hidden: _vm.partsSize === 0,
                              type: "primary",
                            },
                          },
                          [_c("span", [_vm._v("Parts")])]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("parts-list", {
                      attrs: {
                        loading: _vm.loading,
                        requests: _vm.requestList.parts,
                        "status-list": _vm.statusList,
                      },
                      on: { reload: _vm.loadRequests },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tab-pane",
                  { attrs: { name: "refund" } },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _c(
                          "el-badge",
                          {
                            staticClass: "item",
                            attrs: {
                              value: _vm.refundsSize,
                              hidden: _vm.refundsSize === 0,
                              type: "primary",
                            },
                          },
                          [_c("span", [_vm._v("Refunds")])]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("refund-list", {
                      attrs: {
                        loading: _vm.loading,
                        requests: _vm.requestList.refund,
                        "status-list": _vm.statusList,
                      },
                      on: { reload: _vm.loadRequests },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }